import Swiper from "swiper";
import { Pagination } from 'swiper/modules';

const initSingleProductSlider = () => {
    const productPageSliders = Array.from(document.querySelectorAll('.product-page__slider'));

    productPageSliders.forEach(block => {
        if (block.inited) {
            return;
        }
        block.inited = true;

        new Swiper(block, {
            modules: [Pagination],
            loop: true,
            slidesPerView: 1,
            pagination: {
                el: '.product-page__slider-pagination',
                clickable: true,
            },
        });
    });
};

initSingleProductSlider();

export default initSingleProductSlider;
